//#region Common texts
export const ALL = 'Alla'
export const EDIT = 'Redigera'
export const SEARCH = 'Sök'
//#endregion

//#region Request Account
export const REQUEST_ACCOUNT_PAGE_TITLE = 'Ansök om konto'
export const REQUEST_ACCOUNT_EMAIL_LABEL = 'E-postadress'
export const REQUEST_ACCOUNT_EMAIL_PLACEHOLDER = 'Ange din e-postadress'
export const REQUEST_ACCOUNT_EMAIL_REQ_ERROR = 'Du måste ange en e-postadress'
export const REQUEST_ACCOUNT_EMAIL_FORMAT_ERROR = 'Ange en giltig e-postadress'
export const REQUEST_ACCOUNT_PASSWORD_LABEL = 'Lösenord'
export const REQUEST_ACCOUNT_PASSWORD_PLACEHOLDER = 'Välj ett lösenord (minst 8 tecken)'
export const REQUEST_ACCOUNT_PASSWORD_REQ_ERROR = 'Du måste ange ett lösenord'
export const REQUEST_ACCOUNT_PASSWORD_MIN_ERROR = 'Lösenordet måste vara minst 8 tecken'
export const REQUEST_ACCOUNT_PASSWORD_CONFIRM_LABEL = 'Bekräfta lösenord'
export const REQUEST_ACCOUNT_PASSWORD_CONFIRM_PLACEHOLDER = 'Upprepa lösenordet'
export const REQUEST_ACCOUNT_PASSWORD_CONFIRM_REQ_ERROR = 'Du måste bekräfta lösenordet'
export const REQUEST_ACCOUNT_PASSWORD_CONFIRM_MATCH_ERROR = 'Lösenorden stämmer inte överens'
export const REQUEST_ACCOUNT_ORG_LABEL = 'Organisationsnamn'
export const REQUEST_ACCOUNT_ORG_PLACEHOLDER = 'Ange din organisations namn'
export const REQUEST_ACCOUNT_ORG_REQ_ERROR = 'Du måste ange ett organisationsnamn'
export const REQUEST_ACCOUNT_SUBMIT = 'Skicka ansökan'
export const REQUEST_ACCOUNT_SUCCESS =
  'Din ansökan har skickats! En administratör kommer att granska den och du kommer att bli kontaktad via e-post.'
export const REQUEST_ACCOUNT_ERROR = 'Något gick fel. Kontrollera uppgifterna och försök igen.'
export const REQUEST_ACCOUNT_LINK_TEXT = 'Ansök om konto'
//#endregion

//#region Acticities general
export const ACTIVITY_MAX_NO_OF_ATTENDEES = 'Maximalt antal i publiken (eller deltagare)'
//#endregion

//#region Create Acticity
export const ARTFORM = 'Kulturform'
export const CREATE_ACTIVITY_PAGE_TITLE = 'Skapa aktivitet'
export const CREATE_ACTIVITY_PRIMARY_IMAGE = 'Ladda upp omslagsbild'
export const CREATE_ACTIVITY_ARTFORM = 'Konstform'
export const CREATE_ACTIVITY_ARTFORM_DESCRIPTION = 'Välj den konstform som passar in på din aktivitet.'
export const CREATE_ACTIVITY_ARTFORM_REQ_ERROR = 'Du måste välja en konstform'
export const CREATE_ACTIVITY_ARTFORM_DROPDOWN_DEFAULT = 'Välj kulturform'
export const CREATE_ACTIVITY_TARGET_GROUP = 'Målgrupp'
export const CREATE_ACTIVITY_TARGET_GROUP_REQ_ERROR = 'Du måste välja en målgrupp'
export const CREATE_ACTIVITY_TITLE = 'Titel'
export const CREATE_ACTIVITY_TITLE_PLACEHOLDER = 'Skriv namnet på din föreställning eller aktivitet'
export const CREATE_ACTIVITY_TITLE_REQ_ERROR = 'Du måste ange titel'
export const CREATE_ACTIVITY_PREAMBLE = 'Ingress'
export const CREATE_ACTIVITY_PREAMBLE_PLACEHOLDER = 'Skriv en kort sammanfattning av din aktivitet'
export const CREATE_ACTIVITY_PREAMBLE_REQ_ERROR = 'Du måste ange en ingress'
export const CREATE_ACTIVITY_DESCRIPTION = 'Beskrivning'
export const CREATE_ACTIVITY_DESCRIPTION_PLACEHOLDER = 'Beskriv aktiviteten mer utförligt.'
export const CREATE_ACTIVITY_DESCRIPTION_REQ_ERROR = 'Du måste ange en beskrivning'
export const CREATE_ACTIVITY_TAGS = 'Taggar'
export const CREATE_ACTIVITY_TRAILER = 'Länk till trailer'
export const CREATE_ACTIVITY_TRAILER_PLACEHOLDER = 'Här kan du lägga in en länk till en trailer eller ett videoklipp. Skriv hela webbadressen, inklusive http:// eller https:// Har du ingen länk, lämna fältet tomt.'
export const CREATE_ACTIVITY_MATERIAL = 'Länk till pedagogiskt material'
export const CREATE_ACTIVITY_MATERIAL_PLACEHOLDER = 'Om det finns pedagogiskt material till din aktivitet, ange länken här. Har du ingen länk, lämna fältet tomt.'
export const CREATE_ACTIVITY_POSTER = 'Länk till affisch'
export const CREATE_ACTIVITY_POSTER_PLACEHOLDER = 'Om det finns en affisch till din aktivitet, ange länken här. Har du ingen länk, lämna fältet tomt.'
export const CREATE_ACTIVITY_SECONDARY_IMAGE = 'Ladda upp presentationsbild'
export const CREATE_ACTIVITY_ABOUT_TITLE = 'Om föreställningen'
export const CREATE_ACTIVITY_PRICE = 'Pris utan subvention'
export const CREATE_ACTIVITY_PRICE_PLACEHOLDER = 'Ange ett pris'
export const CREATE_ACTIVITY_PRICE_REQ_ERROR = 'Du måste ange ett pris'
export const CREATE_ACTIVITY_PRICE_WITH_SUBVENTION = 'Pris med subvention'
export const CREATE_ACTIVITY_PLAYTIME = 'Spelperiod'
export const CREATE_ACTIVITY_PLAYTIME_FORMAT_ERROR = 'Du måste ange ett giltigt datum'
export const CREATE_ACTIVITY_PLAYTIME_FROM = 'Från'
export const CREATE_ACTIVITY_PLAYTIME_FROM_REQ_ERROR = 'Du måste ange ett startdatum'
export const CREATE_ACTIVITY_PLAYTIME_FROM_ERROR = 'Du måste ange ett senare startdatum'
export const CREATE_ACTIVITY_PLAYTIME_TO = 'Till'
export const CREATE_ACTIVITY_PLAYTIME_TO_REQ_ERROR = 'Du måste ange ett slutdatum'
export const CREATE_ACTIVITY_PLACE = 'Spelplats'
export const CREATE_ACTIVITY_PLACE_PLACEHOLDER = 'Ange en spelplats'
export const CREATE_ACTIVITY_PLACE_REQ_ERROR = 'Du måste ange en spelplats'
export const CREATE_ACTIVITY_LENGTH = 'Längd'
export const CREATE_ACTIVITY_LENGTH_PLACEHOLDER = 'Ange längd'
export const CREATE_ACTIVITY_LENGTH_REQ_ERROR = 'Du måste ange längd'
export const CREATE_ACTIVITY_NO_OF_PARTICIPANTS = 'Antal medverkande'
export const CREATE_ACTIVITY_NO_OF_PARTICIPANTS_PLACEHOLDER = 'Ange antal medverkande'
export const CREATE_ACTIVITY_NO_OF_PARTICIPANTS_REQ_ERROR = 'Du ange antal medverkande'
export const CREATE_ACTIVITY_NO_OF_PARTICIPANTS_TYPE_ERROR = 'Antal medverkande måste vara en siffra'
export const CREATE_ACTIVITY_NO_OF_PARTICIPANTS_MIN_ERROR = 'Du måste ange antal medverkande'
export const CREATE_ACTIVITY_CONTACT_TITLE = 'Kontakt'
export const CREATE_ACTIVITY_CONTACT_DESCRIPTION = 'Kontaktuppgifter uppdateras under “Redigera” på startsidan'
export const CREATE_ACTIVITY_SENDER = 'Avsändare'
export const CREATE_ACTIVITY_SENDER_PLACEHOLDER = 'Ange avsändare'
export const CREATE_ACTIVITY_CONTACT_PERSON = 'Kontaktperson'
export const CREATE_ACTIVITY_CONTACT_PERSON_PLACEHOLDER = 'Ange kontaktperson'
export const CREATE_ACTIVITY_PHONE = 'Telefon'
export const CREATE_ACTIVITY_PHONE_PLACEHOLDER = 'Ange telefon'
export const CREATE_ACTIVITY_EMAIL = 'E-post'
export const CREATE_ACTIVITY_EMAIL_PLACEHOLDER = 'Ange e-post'
export const CREATE_ACTIVITY_ADDRESS = 'Postadress'
export const CREATE_ACTIVITY_ADDRESS_PLACEHOLDER = 'Ange postadress'
export const CREATE_ACTIVITY_HOMEPAGE = 'Webbplats'
export const CREATE_ACTIVITY_HOMEPAGE_PLACEHOLDER = 'Ange Webbplats'
export const CREATE_ACTIVITY_TECHNICAL_DEMANDS_TITLE = 'Tekniska krav'
export const CREATE_ACTIVITY_DIMOUT = 'Mörkläggning'
export const CREATE_ACTIVITY_CONSTRUCTION_TIME = 'Byggtid'
export const CREATE_ACTIVITY_TEAR_DOWN_TIME = 'Rivtid'
export const CREATE_ACTIVITY_CARRYING_AID = 'Bärhjälp'
export const CREATE_ACTIVITY_OUTLET = 'Eluttag'
export const CREATE_ACTIVITY_CEILING_HEIGHT = 'Takhöjd'
export const CREATE_ACTIVITY_PLAY_AREA = 'Spelyta'
export const CREATE_ACTIVITY_OTHER = 'Övrigt'
export const CREATE_ACTIVITY_OTHER_PLACEHOLDER = 'Övrig information'
export const CREATE_ACTIVITY_SAVE_FOR_REVIEW = 'Nöjd, skicka till granskning'
export const CREATE_ACTIVITY_SAVE_DRAFT = 'Spara utkast'
export const CREATE_ACTIVITY_PREVIEW = 'Förhandsgranska'
export const ACTIVITY_MAX_NO_OF_ATTENDEES_PLACEHOLDER = 'Ange max antal publik/deltagare'
export const UNSAVED_CHANGES = 'Det finns osparade ändringar'
//#endregion

//#region Activity
export const ACTIVITY_LINK_TRAILER = 'Visa trailer'
export const ACTIVITY_LINK_MATERIAL = 'Pedagogiskt material'
export const ACTIVITY_LINK_POSTER = 'Affisch'
export const ACTIVITY_LINK_SKOLBIO_SUBVENTION = 'Sök subvention för skolbio'
export const ACTIVITY_LINK_SKOLBIO_SUBVENTION_URL =
  'https://www.regionstockholm.se/kultur/arrangera-kulturupplevelser/filmvisning-och-filmverksamhet/skolbiosubvention/'
export const ACTIVITY_CONTACT_SENDER = 'Avsändare'
export const ACTIVITY_CONTACT_CONTACT_PERSON = 'Kontaktperson'
export const ACTIVITY_CONTACT_PHONE = 'Telefon'
export const ACTIVITY_CONTACT_EMAIL = 'Epost'
export const ACTIVITY_CONTACT_ADDRESS = 'Postadress'
export const ACTIVITY_CONTACT_WEBSITE = 'Webbplats'
export const ACTIVITY_ABOUT_TITLE = 'OM'
export const ACTIVITY_ABOUT_PRICE_WITHOUT_SUBVENTION = 'Pris'
export const ACTIVITY_ABOUT_PRICE_WITH_SUBVENTION = 'Pris med subvention'
export const ACTIVITY_ABOUT_NO_OF_PARTICIPANTS = 'Antal medverkande'
export const ACTIVITY_ABOUT_PLAYING_PERIOD = 'Spelperiod'
export const ACTIVITY_ABOUT_SITE = 'Spelplats'
export const ACTIVITY_ABOUT_SHOW_LENGTH = 'Föreställningens längd'
export const ACTIVITY_TECHNICAL_DEMANDS_TITLE = 'TEKNISKA KRAV'
export const ACTIVITY_TECHNICAL_DEMANDS_BLACKOUT = 'Mörkläggning'
export const ACTIVITY_TECHNICAL_DEMANDS_CONSTRUCTION_TIME = 'Byggtid'
export const ACTIVITY_TECHNICAL_DEMANDS_TEAR_DOWN_TIME = 'Rivtid'
export const ACTIVITY_TECHNICAL_DEMANDS_CARRYING_AID = 'Bärhjälp'
export const ACTIVITY_TECHNICAL_DEMANDS_CARRYING_AID_NO_OF_PEOPLE = 'Antal personer som behövs'
export const ACTIVITY_TECHNICAL_DEMANDS_OUTLET = 'Ellutag behövs'
export const ACTIVITY_TECHNICAL_DEMANDS_CEILING_HEIGHT = 'Takhöjd'
export const ACTIVITY_TECHNICAL_DEMANDS_PLAY_AREA = 'Spelyta'
export const ACTIVITY_TECHNICAL_DEMANDS_OTHER = 'Övrigt'
export const ACTIVITY_RELATED_CONTENT_TITLE = 'Mer från'
export const EDIT_ACTIVITY = 'Redigera aktivitet'
//#endregion

//#region Login
export const USERNAME = 'Användarnamn'
export const USERNAME_PLACEHOLDER = 'Ange användarnamn'
export const USERNAME_REQ_ERROR = 'Ange ett användarnamn'
export const PASSWORD = 'Lösenord'
export const PASSWORD_PLACEHOLDER = 'Ange lösenord'
export const PASSWORD_REQ_ERROR = 'Ange ett lösenord'
export const PASSWORD_VALIDATION_ERROR = 'Lösenordet måste vara minst 8 tecken långt'
export const LOGIN_BUTTON_TEXT = 'Logga in'
export const LOGIN_ERROR = 'Du har angivit fel användarnamn eller lösenord'
//#endregion

//#region ForgotPassword
export const FORGOTPASSWORD_PLACEHOLDER = 'Ange din E-postadress'
export const FORGOTPASSWORD_REQ_ERROR = 'Ange en E-postadress'
export const FORGOTPASSWORD_BUTTON_TEXT = 'Skicka'
export const FORGOTPASSWORD_LINK_TEXT = 'Glömt ditt lösenord?'
export const FORGOTPASSWORD_BACK_TO_LOGIN = 'Tillbaka till inloggning'
export const FORGOTPASSWORD_ERROR = 'Kunde inte hitta användare'
export const FORGOTPASSWORD_SUCCESS =
  'Ett meddelande har skickats till den angivna e-postadressen med all information du behöver för att återställa ditt lösenord'
//#endregion

//#region ResetPassword
export const NEW_PASSWORD = ' Nytt lösenord'
export const CONFIRM_PASSWORD_PLACEHOLDER = 'Bekräfta lösenord'
export const NEW_PASSWORD_PLACEHOLDER = 'Ange nytt lösenord'
export const RESETPASSWORD_BUTTON = 'Återställ lösenord'
export const RESTPASSWORD_TITLE = 'Återställ lösenord'
export const NEW_PASSWORD_REQ_ERROR = 'Ange ett nytt lösenord'
export const CONFIRM_PASSWORD_REQ_ERROR = 'Bekräfta lösenordet stämmer inte överens med det nya lösenordet'
export const RESETPASSWORD_TOKEN_REQ = 'Gick inte att ladda sidan för återställning av lösenord'
export const RESETPASSWORD_ERROR = 'Ett fel uppstod när det nya lösenordet skulle sparas. Försök igen senare'
export const RESETPASSWORD_SUCCESS = 'Ditt lösenord har återställts. Logga in med det nya lösenordet'
//#endregion

//#region My Page
export const MY_PAGE_TITLE = 'Min sida'
export const MY_PAGE_CHOOSE_STATUS = 'Välj status'
export const MY_PAGE_CHOOSE_ART_FORM = CREATE_ACTIVITY_ARTFORM_DROPDOWN_DEFAULT
export const MY_PAGE_CHOOSE_ORGANISATION = 'Välj organisation'
export const MY_PAGE_TABLE_HEADER_STATUS = 'Status'
export const MY_PAGE_TABLE_HEADER_STATUS_ARIA = 'Sortera tabell på status'
export const MY_PAGE_TABLE_HEADER_TITLE = 'Titel'
export const MY_PAGE_TABLE_HEADER_SORT_ON_TITLE_ARIA_LABEL = 'Sortera tabell på titel'
export const MY_PAGE_TABLE_HEADER_DATE = 'Datum'
export const MY_PAGE_TABLE_HEADER_SORT_ON_DATE_ARIA_LABEL = 'Sortera tabell på datum'
export const MY_PAGE_TABLE_HEADER_ARTFORM = ARTFORM
export const MY_PAGE_TABLE_HEADER_SORT_ON_ARTFORM_ARIA_LABEL = 'Sortera tabell på konstform'
export const MY_PAGE_TABLE_HEADER_EDIT = 'Hantera'
export const MY_PAGE_TABLE_EMPTY_TEXT = 'Det finns inga aktiviteter'
//#endregion

//#region Edit Organisation
export const EDIT_ORGANISATION_TITLE_REQ_ERROR = 'Titel krävs'
export const EDIT_ORGANISATION_PREAMBLE_REQ_ERROR = 'Ingress krävs'
export const EDIT_ORGANISATION_MAINBODY_REQ_ERROR = 'Brödtext krävs'
export const EDIT_ORGANISATION_SENDERNAME_REQ_ERROR = 'Avsändare krävs'
export const EDIT_ORGANISATION_CONTACTPERSON_REQ_ERROR = 'Kontaktperson krävs'
export const EDIT_ORGANISATION_PHONE_REQ_ERROR = 'Telefonnummer krävs'
export const EDIT_ORGANISATION_PHONE_PATTERN_ERROR = 'Fel format på telefonnummer'
export const EDIT_ORGANISATION_EMAIL_REQ_ERROR = 'Emailadress krävs'
export const EDIT_ORGANISATION_EMAIL_PATTERN_ERROR = 'Inte en giltig emailadress'
export const EDIT_ORGANISATION_ADDRESS_REQ_ERROR = 'Adress krävs'
export const EDIT_ORGANISATION_WEBSITELINK_PATTERN_ERROR =
  'Länken behöver antingen starta med "https://" eller "http://"'
export const EDIT_ORGANISATION_WEBSITELINK_REQ_ERROR = 'Länk till Webbplats krävs'
export const EDIT_ORGANISATION_MAINBODY_PLACEHOLDER = 'Ange organisationens brödtext'
export const EDIT_ORGANISATION_TITLE = 'Redigera organisation / kulturaktör'
export const EDIT_ORGANISATION_ABOUT_TITLE = 'Om organisationen / kulturaktören'
export const EDIT_ORGANISATION_NAME_TITLE = 'Namn på organisationen / kulturaktören'
//#endregion

//#region Start Page (home)
export const HOME_SEARCH_TITLE = 'Sök kulturaktivitet'
export const HOME_SEARCH_CHOOSE_ARTFORM = CREATE_ACTIVITY_ARTFORM_DROPDOWN_DEFAULT
export const HOME_SEARCH_CHOOSE_TARGET_GROUP = 'Välj målgrupp'
export const HOME_SEARCH_CHOOSE_TAG = 'Egenskaper'
//#endregion

//#region Scroll to top
export const SCROLL_TO_TOP_TEXT = 'Scrolla till toppen av sidan'
//#endregion
